<template>
    <div>
        <div class="testimonial">
            <p class="text-center text-xl">{{ review }}</p>
            <p class="text-xl text-primary font-semibold text-center mt-8">{{  name }}</p>
            <p class="text-sm text-center" v-if="role">{{ role }}</p>
        </div>
    </div>
</template>

<script setup>
defineProps({
    review: {
        type: String,
        default: '',
        required: true
    },
    name: {
        type: String,
        default: '',
        required: true
    },
    role: {
        type: String,
        default: ''
    }
});
</script>

<style lang="scss" scoped>
.testimonial {
    position: relative;
    padding: 80px 150px 56px 150px;
    &:before {
        content: '';
        background-image: url('/images/icons/quotes.svg');
        background-size: 50%;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        height: 100px;
        width: 100px;
        background-repeat: no-repeat;
        background-position-x: center;
    }
    @media (max-width: 767px),(min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) {
        padding: 48px 8px;
    }
}
</style>